import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { CardBody, Form, Row } from "reactstrap";
import { setBreadcrumbItems } from "store/actions";
import Spinners from "components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import * as url from "../../helpers/url_helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const AddCategory = (props) => {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Event", link: "#" },
    { title: "Event Category List", link: "#" },
    { title: "Add Event Category", link: "#" },
  ];
  const { id } = useParams();
  const [categoryName, setCategoryName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  useEffect(() => {
    props.setBreadcrumbItems("Add Event Category", breadcrumbItems);
  });
  function handleEventCategory(e) {
    e.preventDefault(); // Prevent default form submission
    setLoading(true);
    if (!categoryName || !price || !description) {
      return toast.warn("All field are required.");
    }
    const urlPath = `eventcategory/${id}/addCategory/`;
    fetch(url.VUF_APP_API + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        categoryname: categoryName,
        price: price,
        displayMsg: description,
        allowRegister: "true",
        eventId: id,
        status: "true",
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          toast.success("Event Category Added.");
          setTimeout(() => {
            navigate(`/Event/${id}/EventCategoryList/`);
          }, 1000);
        } else {
          alert("Something went wrong, please try again.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Something went wrong, please try again.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <CardBody>
            <div className="container" style={{ maxWidth: "100%" }}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="card card-custom gutter-b example example-compact">
                    <div className="card-header">
                      <h3 className="card-title">Add Event Category</h3>
                    </div>
                    <div className="card-body row col-12">
                      <form onSubmit={handleEventCategory}>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">
                                  Event Category Name
                                </label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    setCategoryName(e.target.value);
                                  }}
                                  className="form-control form-control-solid form-control"
                                  value={categoryName}
                                />
                                <span className="form-text text-danger"></span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">
                                  Category Price:
                                </label>
                                <input
                                  type="number"
                                  onChange={(e) => {
                                    setPrice(e.target.value);
                                  }}
                                  className="form-control"
                                  value={price}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">
                                  Description
                                </label>
                                <textarea
                                  name="eventDescription"
                                  value={description}
                                  onChange={(e) =>
                                    setDescription(e.target.value)
                                  }
                                  className="form-control form-control-solid"
                                />
                                <span className="form-text text-danger"></span>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-md-2">
                              <div className="form-check form-switch">
                                <input
                                  id="customSwitch"
                                  type="checkbox"
                                  className="form-check-input form-check-input"
                                />
                                <label
                                  htmlFor="customSwitch"
                                  className="form-check-label form-label"
                                >
                                  Allow Register
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-check form-switch">
                                <input
                                  id="customSwitch"
                                  type="checkbox"
                                  className="form-check-input form-check-input"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customSwitch"
                                >
                                  Status
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex gap-2">
                            <button
                              type="submit"
                              onSubmit={handleEventCategory}
                              className="btn btn-primary"
                            >
                              <i className="fa fa-plus me-2"></i>Add Event
                              Category
                            </button>
                            <Link
                              className="btn btn-secondary"
                              to={`/Event/${id}/EventCategoryList`}
                            >
                              <i className="fa fa-arrow-left me-2"></i>Back to
                              List
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(AddCategory);
